import logoMain from '/generated/logo-main.png'; // full-color logo

const App = () => {
  return (
    <>
      {/* Header with logo */}
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '20px 40px',
          background: 'linear-gradient(135deg, #0f1a2e, #1a2f4a)',
          borderBottom: '1px solid rgba(0, 255, 180, 0.15)',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
        }}
      >
        <img
          src={logoMain}
          alt="EcoPowerHub AI"
          style={{
            height: '60px',
            width: 'auto',
            marginRight: '20px',
            filter: 'drop-shadow(0 2px 8px rgba(0, 255, 180, 0.3))',
          }}
        />
        <h1
          style={{
            margin: 0,
            fontSize: '28px',
            fontWeight: 700,
            color: '#00ffb4',
            letterSpacing: '1px',
            textShadow: '0 0 10px rgba(0, 255, 180, 0.4)',
          }}
        >
          EcoPowerHub AI
        </h1>
      </header>

      {/* Main content */}
      <main
        style={{
          minHeight: 'calc(100vh - 100px)',
          background: '#f8f9fa',
          color: '#111',
          fontFamily: 'system-ui, sans-serif',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '4rem 2rem',
        }}
      >
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: '#1a3c34' }}>
          Global Smart Energy Optimization on the Blockchain
        </h2>

        <p style={{ fontSize: '1.3rem', maxWidth: '720px', marginBottom: '3rem', lineHeight: 1.6 }}>
          Decentralized AI-powered platform for real-time energy optimization, carbon tracking, and peer-to-peer green energy trading.
        </p>

        <button
          style={{
            background: '#00ffb4',
            color: '#0f1a2e',
            border: 'none',
            padding: '1.2rem 3rem',
            fontSize: '1.4rem',
            fontWeight: 600,
            borderRadius: '12px',
            cursor: 'pointer',
            boxShadow: '0 6px 20px rgba(0, 255, 180, 0.3)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 255, 180, 0.5)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 255, 180, 0.3)';
          }}
        >
          Connect Wallet & Optimize Now
        </button>
      </main>

      {/* Footer */}
      <footer
        style={{
          padding: '2rem',
          background: '#0f1a2e',
          color: '#aaa',
          textAlign: 'center',
          fontSize: '0.95rem',
        }}
      >
        © {new Date().getFullYear()} EcoPowerHub AI — Decentralized • Permanent • Unstoppable
      </footer>
    </>
  );
};

export default App;
